import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Team from './components/Team';
import Footer from './components/Footer';
import './css/App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Header />
        <Hero />
        <About />
        <Services />
        <Team />
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;